// A relation can be recent for either player, even when they played different
// numbers of games afterwards. Only the latest game gets the explicit label.
export function wasLastGameEncounter(history, leftId, rightId) {
  return [[leftId, rightId], [rightId, leftId]].some(([owner, other]) => {
    const latest = history?.[Number(owner)]?.recentMatches?.[0];
    return (latest?.encounteredUserIds || []).some(id => Number(id) === Number(other));
  });
}

export function repeatRecencyLabel(history, leftId, rightId) {
  return wasLastGameEncounter(history, leftId, rightId) ? 'ซ้ำจากเกมที่แล้ว' : 'ซ้ำ';
}
